import { Component, Input, OnInit } from '@angular/core';
import { NamedContact } from 'src/lib/fliko/models/estate/subcontractor.data';

@Component({
  selector: 'app-contact-box',
  templateUrl: './contact-box.component.html',
  styleUrls: ['./contact-box.component.scss']
})
export class ContactBoxComponent implements OnInit {
  @Input() contact!: NamedContact;
  @Input() icons = false;
  constructor() {}

  ngOnInit() {}
}
